// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/DownloadAction/Content/Content/Launchers/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Images_Content_Content_Content_Content_DownloadAction_Content_Content_Launchers($location_id: uuid!, $resource_id: uuid!) {
  apps_launchers(
    slot: ADMIN_PATIENT_IMAGE_SERIES
    location_id: $location_id
    resource_id: $resource_id
  ) {
    id
    shortName
    launchers {
      id
      app_id
      icon
      name
      active
      connected
      type
      error
      description
      properties
    }
  }
}

`